app.service('filterBar', function(modal, filterBox) {
	let filterListModal, categoryListModal;

	function setEvents() {
		$('#category-btn').on('click', () => {
			if (categoryListModal) {
				return categoryListModal.open();
			}

			categoryListModal = modal.generate({
				header: 'Kategorie',
				content: $('#node-tree'),
				modifier: 'remodal-full-width'
			});
	});

		$('#filter-btn').on('click', () => {
			filterBox.init();

			if (filterListModal) {
				return filterListModal.open();
			}

			filterListModal = modal.generate({
				header: 'Filtrowanie',
				content: $('#filter-box'),
				modifier: 'remodal-full-width'
			});
	});
	}

	function init() {
		setEvents();
	}

	return {
		init
	};
});
